import type { HeydayPage } from './heydayPageManifest';

type PageSearchMetadata = {
  label?: string;
  aliases: readonly string[];
  suggestionOrder?: number;
};

// 검색에 노출할 업무를 명시한다. 경로·권한·기본 이름은 page manifest가 소유한다.
// 독립 대량 작업 같은 호환 경로는 메뉴 권한이 있어도 검색에 다시 노출하지 않는다.
export const heydaySearchPages: Partial<Record<HeydayPage, PageSearchMetadata>> = {
  'my-home': { aliases: ['내 홈', '홈 화면'] },
  'my-tasks': { label: '내 할 일', aliases: ['할 일', '할일', '내 결재', '내 승인'], suggestionOrder: 3 },
  'my-workflows': { aliases: ['워크플로우', '업무 요청', '결재 신청', '양식'] },
  'my-workflow-requests': { aliases: ['신청 내역', '요청 내역', '내 신청', '내 요청 이력'] },
  'my-profile': { aliases: ['프로필', '내 프로필', '개인 정보'], suggestionOrder: 5 },
  'my-absence': { label: '내 휴가', aliases: ['휴가', '연차', '반차', '잔여 휴가', '휴가 잔액', '휴가 내역'], suggestionOrder: 4 },
  'my-documents': { aliases: ['증명서', '재직증명서', '경력증명서', '재직 증명서', '경력 증명서'], suggestionOrder: 2 },
  directory: { aliases: ['디렉터리', '동료', '직원 찾기', '사람 찾기', '조직', '부서'] },
  home: { aliases: ['관리자 홈', '관리 현황'] },
  people: { aliases: ['직원', '구성원 관리', '인사 정보', '대량 작업', '일괄 등록', '일괄등록', '기존 재직자 이관'] },
  organization: { label: '조직 관리', aliases: ['조직', '부서 관리', '조직 변경'] },
  staffing: { aliases: ['발령', '전보', '직무 변경', '조직 이동', '대량 작업', '일괄 발령', '일괄발령'] },
  lifecycle: { aliases: ['온보딩', '오프보딩', '입사 준비', '퇴사 준비'] },
  inbox: { aliases: ['승인 대기', '결재', '승인'] },
  absence: { label: '휴가 관리', aliases: ['휴가', '연차', '반차', '직원 휴가', '대량 작업', '일괄 휴가', '일괄휴가'] },
  'absence-settings': { aliases: ['휴가 설정', '연차 정책', '공휴일', '휴일 캘린더'] },
  rewards: { aliases: ['보상', '계약', '복리후생', '급여'] },
  headcount: { aliases: ['정원', '포지션', 'position'] },
  workflow: { aliases: ['워크플로우 운영', '승인 운영', '결재 관리'] },
  'workflow-templates': { aliases: ['워크플로우 양식', '요청 양식', '결재 양식'] },
  'workflow-approval-settings': { aliases: ['승인', '결재선', '결재 설정'] },
  'workflow-requests': { aliases: ['전체 요청', '업무 요청 내역', '신청 내역 관리'] },
  documents: { label: '문서 관리', aliases: ['문서', '첨부파일', '파일'] },
  certificates: { label: '증명서 관리', aliases: ['증명서', '재직증명서', '경력증명서'] },
  'recruiting-home': { aliases: ['채용', '채용 현황'] },
  requisitions: { aliases: ['채용 공고', '채용 신청'] },
  candidates: { aliases: ['지원자 관리', '후보자'] },
  pipeline: { aliases: ['채용 단계', '파이프라인'] },
  interviews: { aliases: ['면접', '평가', '스코어카드'] },
  offers: { aliases: ['오퍼', '채용 제안'] },
  'recruiting-reports': { aliases: ['채용 통계', '채용 리포트'] },
  'admin-company-info': { aliases: ['회사', '회사 이름'] },
  'admin-getting-started': { aliases: ['초기 설정', '시작하기'] },
  'admin-affiliates': { aliases: ['계열사', '법인'] },
  'admin-company-seals': { aliases: ['직인', '도장'] },
  'admin-reference-data': { aliases: ['직무', '직급', '근무지', '사번 규칙'] },
  'admin-appearance': { aliases: ['테마', '브랜드', '로고', '화면 설정'] },
  'admin-features': { aliases: ['앱 설정', '기능 공개'] },
  'admin-security': { aliases: ['관리자', '권한', '보안 설정'] },
  'admin-integrations': { aliases: ['연동 설정', '구글', '슬랙', 'google', 'slack'] },
  'admin-certificates': { aliases: ['증명서 양식', '증명서 정책'] },
  'admin-audit': { aliases: ['내 권한', '접근 정보'] },
};

export const heydaySearchActions: readonly {
  id: string;
  page: HeydayPage;
  action: string;
  label: string;
  aliases: readonly string[];
  query: string;
  suggestionOrder?: number;
}[] = [
  { id: 'request-absence', page: 'my-absence', action: 'request', label: '휴가 신청', aliases: ['연차 신청', '반차 신청', '오전 반차', '오후 반차', '휴가', '연차', '반차'], query: 'action=request', suggestionOrder: 1 },
  { id: 'create-person', page: 'people', action: 'create', label: '구성원 등록', aliases: ['직원 등록', '입사자 등록', '신규 입사', '입사 등록'], query: 'action=create' },
];
